import { getAllDefsClips, getAllDefsGradientAndPattern, getAllShadows, getAllMarkers, getSVGRootAttributes, getClipId, } from './style';
var renderingWidth;
var renderingHeight;
var renderingClips;
var renderingMarkers = [];
var renderingGradientAndPatterns;
var renderingShadows;
var isFigma = false;
export function renderToSVGString(rootGroup, width, height, figma) {
    isFigma = figma;
    renderingWidth = width;
    renderingHeight = height;
    renderingClips = getAllDefsClips(rootGroup);
    renderingGradientAndPatterns = getAllDefsGradientAndPattern(rootGroup);
    renderingShadows = getAllShadows(rootGroup);
    renderingMarkers = getAllMarkers(rootGroup);
    var stringBuffer = [];
    getNodeString(rootGroup, stringBuffer, true);
    renderingClips = null;
    renderingGradientAndPatterns = null;
    return stringBuffer.join('');
}
function getClipString(node, stringBuffer) {
    stringBuffer.push("<clipPath id=\"" + getClipId(node) + "\">");
    getNodeString(node, stringBuffer);
    stringBuffer.push('</clipPath>');
}
function getGradientAndPatternString(item, stringBuffer) {
    getCustomerNodeString(item.getSVGNode(), stringBuffer);
}
function getCustomerNodeString(node, stringBuffer) {
    if (typeof node === 'object') {
        var svgTagName = node.svgTagName, svgAttr = node.svgAttr, childNodes = node.childNodes;
        stringBuffer.push("<" + svgTagName);
        for (var key in svgAttr) {
            stringBuffer.push(" " + key + "=\"" + svgAttr[key] + "\"");
        }
        stringBuffer.push('>');
        childNodes && childNodes.forEach(function (child) { return getCustomerNodeString(child, stringBuffer); });
        stringBuffer.push("</" + svgTagName + ">");
    }
    else {
        stringBuffer.push(node);
    }
}
function getNodeString(node, stringBuffer, isRoot) {
    if (isRoot === void 0) { isRoot = false; }
    var tagName = !isRoot ? node.svgTagName : 'svg';
    var attr = !isRoot
        ? node.getSvgAttributes(isFigma)
        : getSVGRootAttributes(renderingWidth, renderingHeight);
    var children = node.isGroup ? node.children() : null;
    stringBuffer.push("<" + tagName);
    for (var key in attr) {
        stringBuffer.push(" " + key + "=\"" + attr[key] + "\"");
    }
    stringBuffer.push('>');
    if (tagName === 'svg') {
        stringBuffer.push('<defs>');
        renderingClips.forEach(function (clip) { return getClipString(clip, stringBuffer); });
        renderingGradientAndPatterns.forEach(function (item) { return getGradientAndPatternString(item, stringBuffer); });
        renderingShadows.forEach(function (item) { return getCustomerNodeString(item.getSVGNode(), stringBuffer); });
        renderingMarkers.forEach(function (marker) { return getNodeString(marker, stringBuffer); });
        stringBuffer.push('</defs>');
    }
    if (node.type === 'text') {
        var spanList = node.getSpanList();
        if (spanList.length === 1) {
            stringBuffer.push(spanList[0].text);
        }
        else {
            spanList.forEach(function (span) {
                var tspan = {
                    svgTagName: 'tspan',
                    svgAttr: {
                        x: span.x,
                        y: span.y
                    },
                    childNodes: [span.text],
                };
                getCustomerNodeString(tspan, stringBuffer);
            });
        }
    }
    if (tagName === 'marker') {
        getNodeString(node.attr.shape, stringBuffer);
    }
    children && children.forEach(function (child) { return getNodeString(child, stringBuffer); });
    stringBuffer.push("</" + tagName + ">");
}
